export default __webpack_public_path__ + "static/media/p2Pic.4a2fc106.JPG";